module.exports = __webpack_public_path__ + "img/edit_curve.a8a2fae.svg";